import { colors } from '../../colors';
var fiftyFiftyCard = {
  bgColorLight: colors.frost,
  bgColorDark: colors.black,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default fiftyFiftyCard;